import { useQuery } from '@tanstack/react-query';
import { getWorkspaces } from '@/api/Terminal/Workspace';
import { ReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

interface IWorkspacesHookProps {
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  params?: QueryParamsInterface;
}

export const useWorkspaces = ({ onSuccess, onError, params }: IWorkspacesHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [ReactQueryKey.GET_WORKSPACES, params],
    queryFn: () => getWorkspaces(params),
    onSuccess,
    onError,
    select: (data: IGetWorkspacesServiceRes) => [
      {
        name: 'All Program',
        description: 'All Program on your organization account',
        id: 0,
      },
      //...data.data,
      ...(Array.isArray(data?.data) ? data.data : []),
    ],
  });
};
